import { useState, useEffect } from "react"
import { Flex, Input, Modal, Form, DatePicker, List, Pagination, Button, Tag } from "antd"
import ProgramStepper from "../ProgramStepper"
import { useTranslation } from "react-i18next"
import { fetchEvents, fetchEventsMeta } from "../../../api/Cards"
import infologo from "../../../assets/Info.png"
import warninglogo from "../../../assets/Warning.png"
import errorlogo from "../../../assets/Error.png"

export const EventsModal = ({ onClose, metaData }) => {

    const handleClose = () => onClose()

    const handleCancel = () => handleClose()
    const { t } = useTranslation()
    const [eventData, setEventData] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    useEffect(() => {

        async function loadNumEvents() {
            const count = await fetchEventsMeta(metaData);

            setPageCount(count)
        }

        loadNumEvents();
    }, [])

    async function loadEvents() {
        const eventSelector = { metaData: metaData, rangeStart: (pageSize * (currentPage - 1)), rangeEnd: pageSize }
        const data = await fetchEvents(eventSelector)

        if (typeof data == "number") {
            console.log("gone offline ", data)
            return
        }

        setEventData(data)
    }

    useEffect(() => {
        loadEvents()
    }, [pageCount, pageSize, currentPage])


    function onPageChanged(page, pageSize) {
        setCurrentPage(page)
    }

    function onPageSizeChanged(current, size) {
        setPageSize(size)
    }

    function getLogo(Type)
    {
        switch (Type) {
            case 0:
                return infologo;
            case 1:
                return warninglogo;
            case 2:
                return errorlogo;
        }
    }

    function getLogoColor(Type) {
        switch (Type) {
            case 0:
                return 'green';
            case 1:
                return 'orange';
            case 2:
                return 'red';
        }
    }

    function getLogoLabel(Type) {
        switch (Type) {
            case 0:
                return 'INFO';
            case 1:
                return 'WARNING';
            case 2:
                return 'ERROR';
        }
    }

    function isDST(d) {
        let jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
        let jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
        return Math.max(jan, jul) !== d.getTimezoneOffset();
    }

    function getTimeDate(Minutes)
    {
        var DSTOffset = 0;

        var d = new Date("2024-01-01 02:00:00")
        d.setUTCSeconds((Minutes * 60) - DSTOffset)
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            timeZone: "UTC"
        };
        return d.toLocaleDateString("sv-SE", options)
    }


    return (
        <Modal footer={null} width={'635px'} minHeight={'300px'} onCancel={handleCancel} cancelText="Stäng" open>
            <List header={<div style={{fontSize:"23px"}}>{t("page.card-details.events")}</div>} footer={<div></div>}>
                {
                    eventData.map(({EventTime, Message, Title, Type }, i) =>
                    (<List.Item style={{ minHeight: "100px" }} key={i}>
                        <List.Item.Meta
                            title={<span><Tag color={getLogoColor(Type)}>{getLogoLabel(Type)}</Tag>{Title}</span>}
                        />
                        <b>{getTimeDate(EventTime)}</b><br />
                        {Message}
                    </List.Item>)
                    )
                }

            </List>

            <Pagination align="center" defaultCurrent={1} defaultPageSize={10} total={pageCount} onChange={onPageChanged} onShowSizeChange={onPageSizeChanged} />
        </Modal>
    )
}
export default EventsModal